import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-dashboard-banner-logo-icon',
  templateUrl: './dashboard-banner-logo-icon.component.html',
  styleUrls: ['./dashboard-banner-logo-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardBannerLogoIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
